import { AnimatePresence } from "motion/react";
import * as motion from "motion/react-client";
import { Route, Routes, useLocation } from "react-router-dom";
import { ComponentProps } from "react";
import { defaultRouteTransition } from "../transitions";

import Landing from "../screens/Landing";
import Game from "../screens/Game";
import Concert from "../screens/Concert";
import Leaderboard from "../screens/Leaderboard";

export function Router(props: ComponentProps<any>) {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait" initial={false}>
      <Routes key={location.key} location={location}>
        <Route
          key="route--landing"
          path="/"
          element={
            <motion.section key="anim--landing" className="container container--greedy" {...defaultRouteTransition}>
              <Landing {...props} />
            </motion.section>
          }
        />
        <Route
          key="route--game"
          path="/game"
          element={
            <motion.section key="anim--game" className="container container--greedy" {...defaultRouteTransition}>
              <Game {...props} />
            </motion.section>
          }
        />
        <Route
          key="route--concert"
          path="/concert"
          element={
            <motion.section key="anim--concert" className="container container--greedy" {...defaultRouteTransition}>
              <Concert {...props} />
            </motion.section>
          }
        />
        <Route
          key="route--leaderboard"
          path="/leaderboard"
          element={
            <motion.section key="anim--leaderboard" className="container container--greedy" {...defaultRouteTransition}>
              <Leaderboard {...props} />
            </motion.section>
          }
        />
      </Routes>
    </AnimatePresence>
  );
}
